import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */

class GenerateWebVerificationCode extends baseRequest{

    constructor(listener) {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Generate Web Verification Code';
        this.Config   = new AppConfig();
        this.route    = null;
        this.listener = listener;
    }

    // execute(dispatch, payload) {
    //     this.dispatch = dispatch;
    //     this.call(this.Config.api.requests.generateWebVerificationCode, payload);
    // }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.initLogin, payload, 'post', {
            //local
            // basePath: 'http://localhost:8083/relations/api/consents',
            //dev
            basePath: '//' + window.apiUrl + '/users/api/auth',
            stringifyData: true,
        });
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        typeof this.listener === 'function' && this.listener();
    }

    onFailure(){
    }
}


export default GenerateWebVerificationCode;
